import Oauth2LstApi from 'Apis/Oauth2LstApi';
import { vi } from 'date-fns/locale';
import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
import { isMobile } from 'react-device-detect';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
const { v4: uuidv4 } = require("uuid");
declare global {
    interface Window { SsoRespFunc: any; }
}
declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}
const SsoLoginUi = ({ referrer, viewType, onClose }: { referrer?: string | null, viewType: string, onClose?: () => void }) => {
    const { push: gtmPush } = useGtm();
    const navigate = useNavigate();
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (800/2));
    // providers from API
    const [providers, setProviders] = useState<Array<any>>([]);

    const SsoLoginFunc = (e: any) => {
        if (isMobile) {
            window.location.href = e;
        } else {
            window.open(e, "_blank", "width=600,height=800 left=" + popupX + "top=" + popupY);
        }
    }
    const buildFullReferrer = (r?: string | null) => {
        if (!r) return '';
        try {
            const decoded = decodeURIComponent(r);
            // already absolute URL
            if (/^https?:\/\//i.test(decoded)) return decoded;
            // protocol-relative
            if (/^\/\//.test(decoded)) return window.location.protocol + decoded;
            // path-only -> prepend origin
            if (decoded.startsWith('/')) return window.location.origin + decoded;
            // otherwise treat as relative path
            return window.location.origin + '/' + decoded;
        } catch (e) {
            return '';
        }
    };

    const redirectByReferrer = (target: string) => {
        if (!target) {
            navigate("/", { replace: true });
            return;
        }

        if (/^https?:\/\//i.test(target)) {
            try {
                const targetUrl = new URL(target);
                if (targetUrl.origin === window.location.origin) {
                    navigate(`${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`, { replace: true });
                } else {
                    window.location.replace(target);
                }
                return;
            } catch (e) {
                window.location.replace(target);
                return;
            }
        }

        navigate(target, { replace: true });
    };

    useEffect(() =>{
        Oauth2LstApi().then((resp)=> {
            try {
                const list = resp && resp.apiBody && resp.apiBody.oauth2Lst ? resp.apiBody.oauth2Lst : [];
                setProviders(list);
            } catch (err) {
                console.error('Oauth2LstApi parse error', err);
            }
        }).catch(err => {
            console.error('Oauth2LstApi error', err);
        });
        const SsoRespFunc = async (code:string) => {
            switch (code) {
                case"ATHN0000":
                if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                    }
                    const tsKst = getKstTimestamp();
                    const adPayload = await fetchAdPayload( 'BBO');
                    try {

                        gtmPush('BBO_GA_Login_Complete', {
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Login_Complete',
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                        // 리퍼러가 있으면 해당 페이지로, 없으면 홈으로 이동
                        if (viewType === "modal") {
                            if (typeof onClose === 'function') {
                                try { onClose(); } catch (e) { console.error('onClose threw', e); }
                            }
                        }else{
                            if (referrer) {
                                const target = buildFullReferrer(referrer);
                                redirectByReferrer(target);
                            } else {
                                navigate("/", { replace: true });
                            }
                        }
                break;
                case"ATHN2002":
                    navigate("/BlckMemb",{replace:true});   
                break;
                case"ATHN2005":
                    navigate("/membLvdCncl",{replace:true});
                break; 
                case"ATHN2007":
                    // OTP 페이지에도 리퍼러 전달
                    if (referrer) {
                        navigate(`/OtpAthn?referrer=${encodeURIComponent(referrer)}`);
                    } else {
                        navigate("/OtpAthn");
                    }
                break;
                case"ATHN2003":
                    navigate("/DrmcMemb",{replace:true});
                break;        
                case"ATHN2009":
                    if (referrer) {
                        navigate(`/MembJoin?referrer=${encodeURIComponent(referrer)}`, { state: { joinTypeCd: "SSO" } });
                    } else {
                        navigate(`/MembJoin`, { state: { joinTypeCd: "SSO" } });
                    }
                break;
                case "ATHN2309":
                case "BEPR4999":
                    navigate( "/Login", { replace: true });
                break;

            }
        }
        window.SsoRespFunc = SsoRespFunc;
    },[referrer]);

    
    const resolveImg = (src: string | undefined) => {
        if (!src) return '';
        if (/^https?:\/\//.test(src)) return src;
        // assume public path
        return process.env.PUBLIC_URL + (src.startsWith('/') ? src : '/' + src);
    }

    return (
        <>
        <div className='ssoLoginWrap'>
            {providers && providers.length > 0 ? (
                providers.map((p: any) => (
                    <button key={p.provider} className={`colNoneBtn ${'btn' + p.provider}`} onClick={() => {
                        const full = buildFullReferrer(referrer);
                        const url = full ? `${p.mgpApiUrl}&returnUrl=${encodeURIComponent(full)}` : p.mgpApiUrl;
                        SsoLoginFunc(url);
                    }}>
                        <img src={resolveImg(p.imgPUrl || p.imgMUrl)} alt={p.provider} />
                    </button>
                ))
            ) : (
                // fallback: show nothing or placeholder
                null
            )}
        </div>
        </>
    )
}

export default SsoLoginUi;